import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export { Badge, IconWrapper } from '../../styles/nav.styles';

export const IconContainer = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${space['space-100']} ${space['space-400']};
  border-radius: ${size.radius['radius-full']};
  transition: background 0.15s ease;
`;

export const Bar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: var(--keyboard-inset-bottom, 0px);
  left: 0;
  right: 0;
  z-index: 102;
  background: ${semantic.bg.canvas};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding: ${space['space-400']} ${space['space-400']}
    calc(${space['space-400']} + env(safe-area-inset-bottom, 0px));
  height: ${layout.mobileNavHeight};
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

/* `styled.a` so `href` typechecks; rendered `as="button"` when an item has none. */
export const TabItem = styled.a<{ $active?: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-100']};
  padding: 0 ${space['space-200']};
  background: none;
  border: none;
  cursor: pointer;
  color: ${semantic.text.primary};
  text-decoration: none;

  & ${IconContainer} {
    background: ${({ $active }) => ($active ? semantic.bg.surfaceSubtle : 'transparent')};
  }

  &:hover ${IconContainer} {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: -${space['space-050']};
  }
`;

export const TabLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
`;
